/*
 * Module for showing a preview of a content mapping's URL
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "modules/contentsSplit/content/contentPreview/contentPreviewView",
], function (Marionette, Backbone, Messenger, ContentPreviewView) {
  var ContentPreviewController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "contentPreview";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (urlAddress) {
      //If we are passed a url, process it.  Otherwise, set the url to an empty string which will show the standard preview message
      if (urlAddress) {
        urlAddress = this._processUrl(urlAddress);
      } else {
        urlAddress = "";
      }
      //special setup for pdf
      const pdf = urlAddress.endsWith(".pdf");
      //if the url gets downloaded, then mark the download flag as true
      const downloadFlag = this._isDownloaded(urlAddress);
      let downloadFilename;
      if (downloadFlag) {
        downloadFilename = urlAddress.substring(urlAddress.lastIndexOf("/") + 1);
      }
      const model = new Backbone.Model({
        url: urlAddress,
        pdf: pdf,
        downloadFlag: downloadFlag,
        downloadFilename: downloadFilename,
      });
      this.view = new ContentPreviewView.contentPreviewView({ model: model });
      this.showRegion(this.view);
    },
    _isDownloaded: function (urlAddress) {
      //Return true if the file is a word, excel, or ppt doc.  Can add to this list as needed
      var downloadExtensions = [".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".rtf"];
      for (var i = 0; i < downloadExtensions.length; i++) {
        if (urlAddress.endsWith(downloadExtensions[i])) return true;
      }
      return false;
    },
    _processUrl: function (urlAddress) {
      //make sure that the URL starts with http:// or https:// and insert http:// if it doesn't (legacy concern)
      //exception: if there is a default URL
      const defaultUrl = Messenger.reqres.request("kb:default:content:url");
      urlAddress = this._processDefaultUrl(urlAddress, defaultUrl.get("defaultUrl"));
      //the url is a youtube video, so extract the 11 character video ID and use it in an embeddable link so it can be viewed in the preview window
      if (
        urlAddress.startsWith("http://www.youtube") ||
        urlAddress.startsWith("https://www.youtube") ||
        urlAddress.startsWith("http://youtu.be/")
      ) {
        //extract the video code from the last 11 characters of the url
        const videoId = urlAddress.slice(-11);
        //use html5 player for youtube videos by appending "?html5=1" to youtube urls
        urlAddress = "https://www.youtube.com/embed/" + videoId + "?html5=1";
      }
      return urlAddress;
    },
    _processDefaultUrl: function (urlAddress, defaultUrl) {
      if (defaultUrl !== "") {
        if (
          urlAddress.indexOf("://") === -1 &&
          !urlAddress.startsWith("\\") &&
          !urlAddress.startsWith("www.")
        ) {
          var regex = new RegExp(".:\\.*");
          if (!regex.test(urlAddress)) {
            //Make sure we don't double-slash if the default URL ends in / and the current one starts with it.
            //Legacy RD5 supported this, so we should now too so as not to break stuff (and also because it avoids
            //a common pitfall).
            if (defaultUrl.endsWith("/") && urlAddress.startsWith("/")) {
              urlAddress = defaultUrl + urlAddress.substr(1, urlAddress.length - 1);
            } else if (!defaultUrl.endsWith("/") && !urlAddress.startsWith("/")) {
              //no slashes for either
              urlAddress = defaultUrl + "/" + urlAddress;
            } else {
              urlAddress = defaultUrl + urlAddress;
            }
          }
        }
      }
      if (urlAddress.startsWith("www.")) {
        urlAddress = "http://" + urlAddress;
      }
      return urlAddress;
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:preview",
        function (url) {
          if (this.isOpen) {
            console.log("show preview!");
            this.show(url);
          }
        },
        this,
      );
      Messenger.vent.on(
        "hide:preview",
        function () {
          if (this.isOpen) {
            console.log("Hide preview!");
            this.view.hidePreview();
          }
        },
        this,
      );
    },
  });

  return ContentPreviewController;
});
